module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAeUlEQVQ4T2NkoBAwUqifYTgaICEhofDixYsH2MIGmxxKGIAUMDAwHPj792/A69evLyAbIioqasDMzLyBgYHBAdkCjECEKUQ2BJsYzHCssYCsAaQQZDM2V4HkcEYjkpMZcGnGawBIEmQIiEYPD+SwGY4JidTMRXEYAADx0T0RG/VrBQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/arrow_down.png
// module id = gy+e
// module chunks = 0